(function (Drupal) {
  Drupal.behaviors.checkListItemsColumns = {
    attach: function (context, settings) {
      const ul = document.querySelector('.card-service__content ul', context);
      if (!ul) return; 
      const listItems = ul.querySelectorAll('li');
      if (listItems.length > 6) {
        ul.classList.add('over-six-items');
      }
    }
  };
})(Drupal);
  